export const MAX_ANEXO_BYTES = 10 * 1024 * 1024;

export const MOBILE_BREAKPOINT = '(max-width: 899px)';

export const ANEXO_ACCEPT = '.pdf,.png,.jpg,.jpeg';

export const ANEXO_ACCEPT_IMAGEM = 'image/*';

export const ANEXO_ACCEPT_PDF = '.pdf';

export const ANEXO_EXTENSIONS_REGEX = /\.(pdf|jpg|jpeg|png)$/i;

export const ANEXO_MIME_TYPES = ['image/jpeg', 'image/png', 'application/pdf'] as const;

const NOME_GENERICO_CAMERA_REGEX = /^(image|img|photo|capture|camera)(\d*)?(\.(jpg|jpeg|png))?$/i;

export const gerarNomeArquivoFoto = (indice: number): string =>
  `pedido-medico-${indice + 1}.jpg`;

export const isArquivoCamera = (file: File): boolean => {
  const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isImage) return false;

  if (!file.name || !ANEXO_EXTENSIONS_REGEX.test(file.name)) return true;

  return NOME_GENERICO_CAMERA_REGEX.test(file.name);
};

export const formatTamanhoArquivo = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) {
    const kb = bytes / 1024;
    return Number.isInteger(kb) ? `${kb} KB` : `${kb.toFixed(1)} KB`;
  }
  const mb = bytes / (1024 * 1024);
  return Number.isInteger(mb) ? `${mb} MB` : `${mb.toFixed(1)} MB`;
};

export const getExtensaoArquivo = (nomeArquivo: string): string => {
  const extensao = nomeArquivo.slice(nomeArquivo.lastIndexOf('.') + 1);
  return extensao ? extensao.toUpperCase() : '-';
};
